import { Component, OnInit } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Registry } from '@/registry.service';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { RentalPracticesModel } from '@/models/tables/rental-practices.model';
import { DialogRentalPracticesComponent } from '@pages/tables/rental-practices/dialog-rental-practices/dialog-rental-practices.component';

@Component({
  selector: 'app-button-detail-rental-practice',
  templateUrl: '../../button.component.html',
  styleUrls: ['../../button.component.scss'],
})
export class ButtonDetailRentalPracticeComponent extends ButtonComponent implements OnInit {
  faIcon = faPenToSquare;
  private dialogOpened: MatDialogRef<any>;
  private rentalPracticeModel: RentalPracticesModel;
  private rowData: any;

  constructor(
    protected router: Router,
    protected toastr: ToastrService,
    private dialog: MatDialog,
  ) {
    super(router, toastr);

    this.showIcon = true;
    this.additionalClass = 'py-0.5 px-2.5';
    this.toolTip = 'Dettaglio Pratica Noleggio';
    this.smallBtn = true;
  }

  ngOnInit() {
    this.rentalPracticeModel = <RentalPracticesModel>this.rowData;
  }

  /**
   * Open modal new detail page
   */
  public actionClick(): void {
    this.dialogOpened = this.dialog.open(DialogRentalPracticesComponent, {
      data: this.rentalPracticeModel,
    });

    Registry.getInstance().set('DialogRentalPracticeComponentModify', this.dialogOpened);
  }
}
